import { render, staticRenderFns } from "./PlacementsEndComponentReviewPerformance.vue?vue&type=template&id=7b6db0ab&"
import script from "./PlacementsEndComponentReviewPerformance.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentReviewPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports